export default {
  computed: {
    konfirmasi() {
      return [
        {
          title: '<strong style="font-size: 18px">Informasi Laporan</strong>',
          grid: 12,
          instrumen: [
            {
              type: 'VRadio',
              name: 'is_terlaksana',
              label: 'Apakah ada pelaporan refleksi satuan pendidikan pada periode ini ?',
              labelColor: 'grey',
              hint: 'wajib diisi',
              required: true,
              items: [
                { text: 'Ya', value: 1 },
                { text: 'Tidak', value: 0 },
              ],
              grid: { cols: 12, md: 6 },
            },
            {
              show: { status: +this.form.is_terlaksana === 0 },
              type: 'VTextarea',
              name: 'alasan_lain',
              label: 'Alasan tidak adanya pelaporan pada periode ini',
              labelColor: 'grey',
              placeholder: 'Tuliskan alasan tidak adanya pelaporan pada periode ini',
              hint: 'wajib diisi',
              grid: { cols: 12, md: 6 },
              outlined: true,
              dense: true,
              singleLine: true,
              rows: 2,
              autoGrow: true,
            },
          ],
        },
      ];
    },

    schema() {
      return [
        {
          title: '<strong style="font-size: 18px">Informasi Dasar</strong>',
          grid: 12,
          instrumen: [
            {
              type: 'textView',
              label: `Jenjang Sekolah`,
              labelColor: 'grey',
              bgColor: 'grey lighten-3 pa-2',
              value: this.$getDeepObj(this.initValue, 'sekolah.data.m_jenjang.data.singkat') || '-',
              grid: { cols: 12, md: 6 },
            },
            {
              type: 'textView',
              label: `Provinsi Sekolah`,
              labelColor: 'grey',
              bgColor: 'grey lighten-3 pa-2',
              value: this.$getDeepObj(this.initValue, 'sekolah.data.m_propinsi.data.keterangan') || '-',
              grid: { cols: 12, md: 6 },
            },
            {
              type: 'textView',
              label: `Kab / Kota Sekolah`,
              labelColor: 'grey',
              bgColor: 'grey lighten-3 pa-2',
              value: this.$getDeepObj(this.initValue, 'sekolah.data.m_kota.data.keterangan') || '-',
              grid: { cols: 12, md: 6 },
            },
            {
              disabled: this.isPreview,
              type: 'VDatePicker',
              name: 'tgl_pelaksanaan',
              label: 'Waktu Pelaksanaan',
              labelColor: 'grey',
              hint: 'wajib diisi',
              grid: { cols: 12, md: 6 },
              outlined: true,
              dense: true,
              singleLine: true,
            },
            {
              disabled: this.isPreview,
              type: 'VSelect',
              name: 'k_moda',
              label: 'Moda',
              labelColor: 'grey',
              hint: 'wajib diisi',
              grid: { cols: 12, md: 6 },
              items: this.$mapForMaster(this.masters.lokakarya_moda_psp || {}),
              itemText: 'text',
              itemValue: 'value',
              outlined: true,
              dense: true,
              singleLine: true,
            },
            {
              type: 'textView',
              label: `Durasi (dalam JP)`,
              labelColor: 'grey',
              bgColor: 'grey lighten-3 pa-2',
              value: '3',
              grid: { cols: 12, md: 6 },
            },
          ],
        },
        {
          title: '<strong style="font-size: 18px">Detail Laporan</strong>',
          grid: 12,
          instrumen: [
            {
              disabled: this.isPreview,
              type: 'VTextarea',
              name: 'tema',
              label: 'Tema refleksi',
              labelColor: 'grey',
              grid: { cols: 12 },
              outlined: true,
              dense: true,
              singleLine: true,
              rows: 4,
              hint: `Minimum 20 karakter dan maksimum tidak terhingga`,
              autoGrow: true,
            },
            {
              disabled: this.isPreview,
              type: 'VTextarea',
              name: 'praktik_baik',
              label: 'Praktik baik yang tergali saat refleksi',
              labelColor: 'grey',
              grid: { cols: 12 },
              outlined: true,
              dense: true,
              singleLine: true,
              rows: 4,
              hint: `150 - 300 kata`,
              counter: 300,
              autoGrow: true,
              counterValue: (v) => this.$wordCount(v),
            },
            {
              disabled: this.isPreview,
              type: 'VTextarea',
              name: 'peningkatan',
              label: 'Hal yang perlu ditingkatkan oleh Kepala Sekolah dan Guru',
              labelColor: 'grey',
              grid: { cols: 12 },
              outlined: true,
              dense: true,
              singleLine: true,
              rows: 4,
              hint: `150 - 300 kata`,
              counter: 300,
              autoGrow: true,
              counterValue: (v) => this.$wordCount(v),
            },
            {
              disabled: this.isPreview,
              type: 'VTextarea',
              name: 'rencana_sekolah',
              label: 'Rencana tindak lanjut sekolah',
              labelColor: 'grey',
              grid: { cols: 12 },
              outlined: true,
              dense: true,
              singleLine: true,
              rows: 4,
              hint: `150 - 300 kata`,
              counter: 300,
              autoGrow: true,
              counterValue: (v) => this.$wordCount(v),
            },
            {
              disabled: this.isPreview,
              type: 'VTextarea',
              name: 'rencana_pa',
              label: 'Rencana tindak lanjut Fasilitator Sekolah Penggerak',
              labelColor: 'grey',
              grid: { cols: 12 },
              outlined: true,
              dense: true,
              singleLine: true,
              rows: 4,
              hint: `150 - 300 kata`,
              counter: 300,
              autoGrow: true,
              counterValue: (v) => this.$wordCount(v),
            },
          ],
        },
      ];
    },
  },
};
